const obj = {
  //搜索页面
  search: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_searchs_results',
        col: 12
      }
    ]
  },

  //新闻详情
  article: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_article_info',
        col: 12
      }
    ]
  },

  //帮助详情
  help: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_article_info',
        col: 12
      }
    ]
  },

  //案例详情
  case: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_article_info',
        col: 12
      }
    ]
  },

  //新闻列表
  article_index: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_article_classification',
        col: 3
      },
      {
        name: 'basic_article_list',
        col: 9
      }
    ]
  },
  //帮助列表
  help_index: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_article_classification',
        col: 3
      },
      {
        name: 'basic_article_list',
        col: 9
      }
    ]
  },
  //案例列表
  case_index: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_article_classification',
        col: 3
      },
      {
        name: 'basic_article_list',
        col: 9
      }
    ]
  },

  //产品详情
  product: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_product_detail',
        col: 12
      }
    ]
  },

  //产品列表
  product_index: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_product_classification',
        col: 3
      },
      {
        name: 'basic_product_display',
        col: 9
      }
    ]
  },

  //视频列表
  video_index: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_classification', // 没有看懂这个 部分是干啥的
        col: 3
      },
      {
        name: 'basic_video_display',
        col: 9
      }
    ]
  },
  // 视频详情 basic_video_detail_edit
  video: {
    rowType: 'body',
    modules: [{
      name: 'basic_video_detail',
      col: 12
    }]
  },

  //下载列表
  download_index: {
    rowType: 'body',
    modules: [
      {
        name: 'basic_classification', // 没有看懂这个 部分是干啥的
        col: 3
      },
      {
        name: 'basic_download_display',
        col: 12
      }
    ]
  },
  // 用户登录 basic_login
  user_login: {
    rowType: 'body',
    rowConfig: {
      pcPaddingLeft: '0',
      pcPaddingRight: '0'
    },
    modules: [{
      name: 'basic_login',
      col: 12
    }]
  },

  'user_register': {
    rowType: 'body',
    rowConfig: {
      pcPaddingLeft: '0',
      pcPaddingRight: '0'
    },
    modules: [{
      name: 'basic_member_register',
      col: 12
    }]
  },

  'user_index': {
    rowType: 'body',
    modules: [{
      name: 'basic_member_center',
      col: 12
    }]
  },
  'user_forget': {
    rowType: 'body',
    modules: [{
      name: 'basic_retrieve_password',
      col: 12
    }]
  },

}
// 页面是在这儿配置的吗 看着好像是的
export default obj



// WEBPACK FOOTER //
// ./src/base/page_module_config.js